export default "__VITE_ASSET__BJmHj4M7__"